import React from 'react'
import pr1 from '../../images/event/up_event1.png'
import pr2 from '../../images/event/up_event2.png'
import pr3 from '../../images/event/up_event3.png'
import pr4 from '../../images/event/up_event4.png'
import pr5 from '../../images/event/up_event5.png'

import './style.css'

const EventSection = (props) => {
     
    const eventData = [
        {
            id: 1,
            title: 'Mime Workshop',
            date: '25 NOV',
            time: '8.00 - 5.00',
            location: 'Newyork City',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
            image: pr1
        },
        {
            id: 2,
            title: 'Nirbaak Roadsafety conclave',
            date: '25 NOV',
            time: '8.00 - 5.00',
            location: 'Newyork City',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
            image: pr2
        },
        {
            id: 3,
            title: 'Nirbaak Xondhya',
            date: '25 NOV',
            time: '8.00 - 5.00',
            location: 'Newyork City',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
            image: pr3
        },
        {
            id: 4,
            title: 'Nirbaak Prakriti',
            date: '25 NOV',
            time: '8.00 - 5.00',
            location: 'Newyork City',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
            image: pr4
        },
        {
            id: 5,
            title: 'Nirbaak for Youth',
            date: '25 NOV',
            time: '8.00 - 5.00',
            location: 'Newyork City',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
            image: pr5
        }
    ]

    const orderEventData = [...eventData].reverse()

    return(
        <div className="wpo-event-area section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-section-title">
                            <span>Our Events</span>
                            <h2>Upcoming Events</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {orderEventData.map((event) => (
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12 custom-grid">
                        <div className="wpo-event-item">
                            <div className="wpo-event-img">
                                <img src={event.image} alt=""/>
                                {/* <div className="thumb-text">
                                    <span>25</span>
                                    <span>NOV</span>
                                </div> */}
                            </div>
                            <div className="wpo-event-text">
                                <h2>{event.title}</h2>
                                {/* <ul>
                                    <li><i className="fa fa-clock-o" aria-hidden="true"></i>{event.time}</li>
                                    <li><i className="fi flaticon-pin"></i>{event.location}</li>
                                </ul>
                                <p>{event.description}</p>
                                <Link onClick={ClickHandler} to="/event-details">Learn More...</Link> */}
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EventSection;